module.exports = __webpack_public_path__ + "media/images/teams/logo__5-b4f5c5fd2bb359204e3ef55516a29ec9.svg";